const PAGE_NAMES = {
  COMPANY: "Company",
  PROJECTS: "Projects",
  PRODUCTS: "Products",
  PRODUCTSPOST: "Product Post",
  POST: "Dashboard Post",
  CHAT: "Chat",
  SITES: "Sites",
  JOBPOSTINGS: "Job Postings",
  MANUFACTURES: "Manufacturers",
  TRADES: "Trades",
  REVIEW: "Review",
  GLOBAL_SEARCH: "Global Search"
};

const Pages = {
  // Dashboard related pages
  post: {
    id: 129,
    name: PAGE_NAMES.POST
  },
  postComment: {
    id: 461,
    name: PAGE_NAMES.POST
  },
  // Chat related pages
  chat: {
    id: 75,
    name: PAGE_NAMES.CHAT
  },
  // Company related pages
  companies: {
    id: 93,
    name: PAGE_NAMES.COMPANY
  },
  companiesProfile: {
    id: 93,
    name: PAGE_NAMES.COMPANY
  },
  companiesProjects: {
    id: 93,
    name: PAGE_NAMES.PROJECTS
  },
  companiesProducts: {
    id: 109,
    name: PAGE_NAMES.PRODUCTS
  },
  // Product related pages
  product: {
    id: 109,
    name: PAGE_NAMES.PRODUCTS
  },
  productProfile: {
    id: 109,
    name: PAGE_NAMES.PRODUCTS
  },
  productPost: {
    id: 109,
    name: PAGE_NAMES.PRODUCTSPOST
  },
  productProject: {
    id: 173,
    name: PAGE_NAMES.PROJECTS
  },
  productCompanies: {
    id: 93,
    name: PAGE_NAMES.COMPANY
  },
  productReview: {
    id: 374,
    name: PAGE_NAMES.REVIEW
  },
  // Site related pages
  site: {
    id: 159,
    name: PAGE_NAMES.SITES
  },
  siteProject: {
    id: 173,
    name: PAGE_NAMES.PROJECTS
  },
  // Jobposting related pages
  jobPostings: {
    id: 64,
    name: PAGE_NAMES.JOBPOSTINGS
  },
  // Manufacture related pages
  manufacturers: {
    id: 108,
    name: PAGE_NAMES.MANUFACTURES
  },
  manufacturersProjects: {
    id: 173,
    name: PAGE_NAMES.PROJECTS
  },
  manufacturersProducts: {
    id: 109,
    name: PAGE_NAMES.PRODUCTS
  },
  // Trades related pages
  trades: {
    id: 116,
    name: PAGE_NAMES.TRADES
  },
  tradesProject: {
    id: 173,
    name: PAGE_NAMES.PROJECTS
  },
  tradesProducts: {
    id: 109,
    name: PAGE_NAMES.PRODUCTS
  },
  tradesCompanies: {
    id: 93,
    name: PAGE_NAMES.COMPANY
  },
  // Project related pages
  projects: {
    id: 173,
    name: PAGE_NAMES.PROJECTS
  },
  projectProducts: {
    id: 174,
    name: PAGE_NAMES.PRODUCTS
  },
  projectCompanies: {
    id: 178,
    name: PAGE_NAMES.COMPANY
  },
  globalSearch: {
    id: 161,
    name: PAGE_NAMES.GLOBAL_SEARCH
  }
};

export default Pages;
